import { Td, Tr } from '@chakra-ui/react';
import { formatPrice } from '../../../utils/formatPrice';

export function Row({ item, mktValue, totalChamadosNovosVendedor }) {
  const mktPerVendedor = (mktValue || 0 / totalChamadosNovosVendedor) * item.quantidade_novos;
  const mktPerChamado = mktPerVendedor / item.quantidade_novos || 0;
  const mktPerPedido =
    item.total_pedidos_clientes_novos > 0 ? mktPerVendedor / item.total_pedidos : 0;

  return (
    <Tr key={item.total_pedidos + item.valor_total_pedidos}>
      <Td textTransform="capitalize" borderRight="1px solid #cecece!important">
        {item.nome_vendedor}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.chamados_site}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.chamados_wp}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.chamados_atendimento}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.total_chamados}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.total_pedidos}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.total_pedidos_clientes_novos}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.valor_total_pedidos}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {item.valor_pedido_cadastrado}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {formatPrice(mktPerVendedor)}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center">
        {formatPrice(mktPerChamado)}
      </Td>
      <Td textAlign="center">{formatPrice(mktPerPedido)}</Td>
    </Tr>
  );
}
